import React from "react";

const InfographicsDetails = () => {
  return <div>InfographicsDetails</div>;
};

export default InfographicsDetails;
